module.exports = __webpack_public_path__ + "static/media/pentagon.09f2e414.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/pentagon.svg
// module id = 679
// module chunks = 0